import SkipToMainComponent from './component'
export default SkipToMainComponent
